<template>
  <div class="pb-5">
    <table-element
      :isShowFilter="true"
      :title="inactive ? $t('Users.inactiveTitle') : $t('Users.title')"
      :fields="fieldsObj"
      :arrOfElement="displayedUsers"
      :sortSpacing="0"
      class="card mx-2 mb-5 mt-2"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(user, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
            <td class="nowrap"><p class="table-fix-width">{{user.firstName}}</p></td>
            <td>{{user.lastName}}</td>
            <td class="nowrap"><p class="table-fix-width">{{user.email}}</p></td>
            <td>{{user.phoneNumber}}</td>
            <td>{{getRole(user.role)}}</td>
            <td>{{user.password}}</td>
            <td v-if="isGeotabDriverMapped(user.geotabId)">
              <button class="btn btn-kne-orange" >
                <i class="fa fa-check" aria-hidden="true" />
              </button>
            </td>
            <td v-if="!isGeotabDriverMapped(user.geotabId)">
              <button class="btn btn-kne-orange">
                <i class="fa fa-times" aria-hidden="true" />
              </button>
            </td>
            <template v-if="inactive">
              <td>
                <input @click.prevent="reactivateUser(user)" :disabled="!isAdmin || isViewer" type="button" class="btn btn-kne-orange pull-right" :value="$t('Users.reactivate')">
              </td>
              <td></td>
            </template>
            <template v-else>
              <td>
                <input @click.prevent="modifying(user); setModalTitle($t('Users.modifyTitle'))" :disabled="!isAdmin || isViewer" type="button" class="btn btn-kne-orange pull-right" :value="$t('Users.modify')">
              </td>
              <td>
                <input @click.prevent="modifyingAuth(user); setModalTitle($t('Users.updateAuthTitle'))" :disabled="!isAdmin || isViewer" type="button" class="btn btn-kne-orange pull-right" :value="$t('Users.updateAuth')">
              </td>
            </template>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <transition-group name="fade">
          <div class="card my-3 mx-2" v-for="user in content.results" :key="user['.key']">
            <div class="card-header m-2">
              <h4>{{user.firstName}} {{user.lastName}}</h4>
              <p><i class="fa fa-envelope mr-1" />{{user.email}}</p>
            </div>
            <div class="m-2">
              <p><i class="fa fa-phone" /> {{user.phoneNumber}}</p>
              <p><i class="fa fa-users" /> {{getRole(user.role)}}</p>
              <p><i class="fa fa-lock " /> {{user.password}}</p>
              <div id="action" v-if="!isViewer">
                <input v-if="inactive" @click.prevent="reactivateUser(user)" :disabled="!isAdmin" type="button" class="btn btn-kne-orange pull-right" :value="$t('Users.reactivate')">
                <input v-else @click.prevent="modifying(user); setModalTitle($t('Users.modifyTitle'))" type="button" class="btn btn-kne-orange pull-right" :value="$t('Users.modify')">
              </div>
            </div>
          </div>
        </transition-group>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />
    
    <transition name="fade">
      <modal
        :title="modalTitle"
        v-if="modifyAuth"
        @close-request="modifyAuth = false; clear()"
        closable
      >
        <div class="m-3 w-50">
          <label for="email">
            {{$t(userFields.email.label)}}*
            <hover-tool-tip
              :text="$t('Users.modal.email_tooltip')"
              top
              right
            />
          </label>
          <regular-input
            id="email"
            :value="user.email"
            @input="user.email = $event"
            type="text" 
            :placeholder="$t(userFields.email.placeholder)" 
            class="form-group"
          />

          <label for="password">
            {{$t(userFields.password.label)}}*
            <hover-tool-tip
              :text="$t('Users.modal.password_tooltip')"
              top
              right
            />
          </label>
          <regular-input
            id="password"
            :value="user.password"
            @input="user.password = $event"
            type="text" 
            :placeholder="$t(userFields.password.placeholder)" 
            class="form-group"
          />

         <button class="btn btn-kne-orange " @click="updateUserCredentials">{{$t('Users.modal.updateAuth')}} </button>
        </div>
      </modal>  
    </transition>

    <!-- Modal -->
    <transition name="fade">
      <modal
        :title="modalTitle"
        v-if="add || modify"
        @close-request="add = false; modify = false; clear()"
        closable
      >
        <div>
          <label class="col-12" for="role">{{$t(userFields.role.label)}}*</label>
          <regular-select
          id="role"
          :value="user.role"
          @change="user.role = $event"
          :disabled="modify && !isAdmin && user.role === 'Administrateur'"
          :placeholder="$t('Users.role')" class="col-12 form-group">
            <option :disabled="!isAdmin" value="Administrateur">{{ $t('Users.admin') }}</option>
            <option :value="enums.userRoles.driver">{{ $t('Users.driver') }}</option>
            <option :value="enums.userRoles.dispatch">{{ $t('Users.dispatch') }}</option>
            <option :value="enums.userRoles.subcontractor">{{ $t('Users.subcontractor') }}</option>
            <option :value="enums.userRoles.exclusiveSubcontractor">{{ $t('Users.exclusiveSubcontractor') }}</option>
            <option :value="enums.userRoles.other">{{ $t('Users.other') }}</option>
            <option :value="enums.userRoles.viewer">{{ $t('Users.viewer') }}</option>
          </regular-select>

          <div v-if="showSisterCompanyAccess" class="col-12 form-group sister-company-access">
            <label>{{ $t('Users.sisterCompanyAccess') }}</label>
            <p class="sister-company-access__help">{{ $t('Users.sisterCompanyAccessHelp') }}</p>
            <p v-if="sisterCompaniesLoading">{{ $t('Users.loadingSisterCompanies') }}</p>
            <div v-else>
              <regular-checkbox
                v-for="company in manageableSisterCompanies"
                :key="company.uid"
                :checked="selectedSisterCompanyUIDs.includes(company.uid)"
                :label="company.companyName || company.uid"
                @change="toggleSisterCompany(company.uid, $event)"
              />
            </div>
          </div>

          <label class="col-12" for="firstName">{{$t(userFields.firstName.label(user.role))}}*</label>
          <regular-input
          id="firstName"
          :value="user.firstName"
          @input="user.firstName = $event"
          type="text" :placeholder="$t(userFields.firstName.placeholder(user.role))" class="col-12 form-group"/>

          <label class="col-12" for="lastName">{{$t(userFields.lastName.label(user.role))}}*</label>
          <regular-input
          id="lastName"
          :value="user.lastName"
          @input="user.lastName = $event"
          type="text" :placeholder="$t(userFields.lastName.placeholder(user.role))" class="col-12 form-group"/>

          <label class="col-12" for="phoneNumber">{{$t(userFields.phoneNumber.label)}}*</label>
          <regular-input
          id="phoneNumber"
          :value="user.phoneNumber"
          @input="user.phoneNumber = $event"
          type="text" :placeholder="$t(userFields.phoneNumber.placeholder)" class="col-12 form-group"/>

          <label class="col-12" for="email">
            {{$t(userFields.email.label)}}*
            <hover-tool-tip
              :text="$t('Users.modal.email_tooltip')"
              top
              right
            />
          </label>
          <regular-input
          id="email"
          :disabled="modify"
          :value="user.email"
          @input="user.email = $event"
          type="text" :placeholder="$t(userFields.email.placeholder)" class="col-12 form-group"/>

          <label class="col-12" for="password">
            {{$t(userFields.password.label)}}*
            <hover-tool-tip
              :text="$t('Users.modal.password_tooltip')"
              top
              right
            />
          </label>
          <regular-input
          id="password"
          :disabled="modify"
          :value="user.password"
          @input="user.password = $event"
          type="text" :placeholder="$t(userFields.password.placeholder)" class="col-12 form-group"/>

          <label class="col-12" for="driverCountry" 
            v-if="isAdmin">
            {{ $t(userFields.geotabDriver.label) }}
          </label>
          <div class="col-12 form-group" v-if="isAdmin">
            <multi-select :options="drivers" :selected-options="selectedDrivers" 
             @select="handleDriversSelect" :placeholder="$t(userFields.geotabDriver.placeholder)" 
             :multiple="false" />
          </div>
        </div>

        <div v-if="userFields.companyName.roles.includes(user.role)">
          <label class="col-12" for="companyName">{{$t(userFields.companyName.label)}} *</label>
          <regular-input
          id="companyName"
          :value="user.companyName"
          @input="user.companyName = $event"
          type="text" :placeholder="$t(userFields.companyName.placeholder)" class="col-12 form-group"/>
        </div>

        <div v-if="userFields.tps.roles.includes(user.role)">
          <label class="col-12" for="tps">{{$t(userFields.tps.label)}} *</label>
          <regular-input
          id="tps"
          :value="user.tps"
          @input="user.tps = $event"
          type="text" :placeholder="$t(userFields.tps.placeholder)" class="col-12 form-group"/>
        </div>

        <div v-if="userFields.tvq.roles.includes(user.role)">
          <label class="col-12" for="tvq">{{$t(userFields.tvq.label)}} *</label>
          <regular-input
          id="tvq"
          :value="user.tvq"
          @input="user.tvq = $event"
          type="text" :placeholder="$t(userFields.tvq.placeholder)" class="col-12 form-group"/>
        </div>

        <div v-if="userFields.hiringDate.roles.includes(user.role)">
          <label class="col-12" for="hiringDate">{{$t(userFields.hiringDate.label)}} *</label>
          <regular-input
          id="hiringDate"
          :value="user.hiringDate"
          @input="user.hiringDate = $event"
          type="date" :placeholder="$t(userFields.hiringDate.placeholder)" class="col-12 form-group"/>
        </div>

        <div v-if="userFields.driverCountry.roles.includes(user.role)">
          <label class="col-12" for="driverCountry">{{$t(userFields.driverCountry.label)}} *</label>
          <regular-select
          id="driverCountry"
          :value="user.driverCountry"
          @change="user.driverCountry = $event"
          :disabled="modify && !isAdmin && user.role === 'Administrateur'"
          :placeholder="$t(userFields.driverCountry.placeholder)" class="col-12 form-group">
            <option value="US">US</option>
            <option value="CA">CA</option>
          </regular-select>
        </div>
        <!-- Driving Record Fields -->
        <div v-if="userFields.drivingRecord.roles.includes(user.role)">
          <label class="col-12" for="drivingRecord">{{$t(userFields.drivingRecord.label)}} *</label>
          <div class="row col-12 mb-3">
            <div class="col-6">
              <custom-vue-dropzone
                :dropzoneMessage="$t(userFields.drivingRecord.dropzone)"
                :maxFile="1"
                :allowedFileTypes="['.pdf', '.jpeg', '.jpg', '.png']"
                @dropzoneFile="uploadDrivingRecord"
              />
            </div>
            <div class="col-12">
              <table class="table mt-2">
                <tbody>
                  <tr v-if="user.drivingRecord">
                    <td><p class="col-12">{{$t('Users.uploadedFiles')}} : <span><a :href="user.drivingRecord" target="_blank">{{ user.drivingRecord.split('_')[1] }}</a></span></p></td>
                  </tr>
                </tbody>
              </table>
            </div>    
          </div>
        </div>

        <!-- Agreed Hourly Rate - Driver Fields-->
        <div v-if="userFields.agreedHourlyRate.roles.includes(user.role)">
          <label class="col-12">{{$t(userFields.agreedHourlyRate.label)}}</label>
          <div class="col-12">
            <table class="table">
              <tbody>
                <tr>
                  <th class="d-table-cell align-middle col-4" scope="row">
                    <p>{{ $t(userFields.agreedHourlyRate.perHours.label) }}</p>
                  </th>
                  <td>
                    <label class="col-12" for="on">{{$t(userFields.agreedHourlyRate.perHours.on.label)}} *</label>
                    <regular-input
                      id="on"
                      :value="user.agreedHourlyRate.perHours.on"
                      @input="user.agreedHourlyRate.perHours.on = $event"
                      type="number" :placeholder="$t(userFields.agreedHourlyRate.perHours.on.label)" class="col-12 form-group"/>
                  </td>
                  <td>
                    <label class="col-12" for="drive">{{$t(userFields.agreedHourlyRate.perHours.drive.label)}} *</label>
                    <regular-input
                      id="drive"
                      :value="user.agreedHourlyRate.perHours.drive"
                      @input="user.agreedHourlyRate.perHours.drive = $event"
                      type="number" :placeholder="$t(userFields.agreedHourlyRate.perHours.drive.label)" class="col-12 form-group"/>
                  </td>
                </tr>
                <tr>
                  <th class="d-table-cell align-middle" scope="row">
                    <p>{{ $t(userFields.agreedHourlyRate.fixedHours.label) }}</p>
                  </th>
                  <td>
                    <regular-input
                      id="agreedHourlyRate"
                      :value="user.agreedHourlyRate.fixedHours"
                      @input="user.agreedHourlyRate.fixedHours = $event"
                      type="number" :placeholder="$t(userFields.agreedHourlyRate.fixedHours.label)" class="col-12 form-group"/>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th class="d-table-cell align-middle" scope="row">
                    <p>{{ $t(userFields.agreedHourlyRate.perKM.label) }}</p>
                  </th>
                  <td>
                    <regular-input
                      id="agreedHourlyRate"
                      :value="user.agreedHourlyRate.perKM"
                      @input="user.agreedHourlyRate.perKM = $event"
                      type="number" :placeholder="$t(userFields.agreedHourlyRate.perKM.label)" class="col-12 form-group"/>
                  </td>
                  <td></td>
                </tr>
                <!-- Region wise rates -->
                <tr>
                  <th class="d-table-cell align-middle" scope="row">
                    <p>{{$t(userFields.agreedHourlyRate.us)}} *</p>
                  </th>
                  <td>
                    <regular-input
                      id="us"
                      :value="user.agreedHourlyRate.us"
                      @input="user.agreedHourlyRate.us = $event"
                      type="number" :placeholder="$t(userFields.agreedHourlyRate.us)" class="col-12 form-group"/>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th class="align-middle" scope="row">{{$t(userFields.agreedHourlyRate.lastModificationDate.label)}} *</th>
                  <td>
                    <regular-input
                      id="agreedHourlyRate"
                      :value="user.agreedHourlyRate.lastModificationDate"
                      @input="user.agreedHourlyRate.lastModificationDate = $event"
                      type="date" :placeholder="$t(userFields.agreedHourlyRate.lastModificationDate.label)" class="col-12 form-group"/>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div class="col-12">
              <table class="table" v-if="user.distanceVariables && user.distanceVariables.length>0">
                <tbody>
                  <tr>
                    <th class="text-center">{{ $t(userFields.agreedHourlyRate.variables.lower) }}</th>
                    <th class="text-center">{{ $t(userFields.agreedHourlyRate.variables.upper) }}</th>
                    <th class="text-center">{{ $t(userFields.agreedHourlyRate.variables.price) }}</th>
                    <th></th>
                  </tr>
                  <tr v-for="dvSet, index of user.distanceVariables">
                    <td>
                      <regular-input
                        id="lower"
                        :value="dvSet.lower"
                        @input="dvSet.lower = $event"
                        :disabled="true"
                        type="text" :placeholder="$t(userFields.agreedHourlyRate.variables.lower)" class="col-12"/>
                    </td>
                    <td>
                      <regular-input
                        v-if="!(index == user.distanceVariables.length-1)"
                        id="upper"
                        :value="dvSet.upper"
                        @input="dvSet.upper = $event"
                        type="text" :placeholder="$t(userFields.agreedHourlyRate.variables.upper)" class="col-12"/>
                    </td>
                    <td>
                      <regular-input
                        id="value"
                        :value="dvSet.value"
                        @input="dvSet.value = $event"
                        type="text" :placeholder="$t(userFields.agreedHourlyRate.variables.price)" class="col-12"/>
                    </td>
                    <td><button class="btn btn-light" @click="removeDistanceVariables(index)"><strong>&times;</strong></button></td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 text-center">
                <button class="btn btn-light" @click="validateDistanceVariables()" v-if="user.distanceVariables.length > 1">{{$t(userFields.agreedHourlyRate.variables.validate)}}</button>
                <button class="btn btn-light" @click="addDistanceVariables()">{{$t(userFields.agreedHourlyRate.variables.add)}}</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Insurance Fields -->
        <div v-if="userFields.insurance.roles.includes(user.role)">
          <label class="col-12" for="insurance">{{$t(userFields.insurance.label)}} *</label>

          <div v-if="userFields.insurance.isInsured.roles.includes(user.role)" class="col-12 align-middle mb-3">
            <div class="row col-12 mb-2">
              <label class="col-3" for="isInsured">{{$t(userFields.insurance.isInsured.label)}}</label>
              <regular-checkbox
                :checked="user.insurance.isInsured"
                @change="user.insurance.isInsured = $event"
                class="p-0 col-3 hourlyCheckBox"/>
            </div>

            <div v-if="user.insurance.isInsured">
              <label class="col-12" for="insuranceAmount">{{$t(userFields.insurance.insuranceAmount.label)}} *</label>
              <regular-input
                id="insuranceAmount"
                :value="user.insurance.insuranceAmount"
                @input="user.insurance.insuranceAmount = $event"
                type="number" :placeholder="$t(userFields.insurance.insuranceAmount.label)" class="col-12 form-group"/>
            </div>
          </div>

          <div v-if="userFields.insurance.serviceAgreement.roles.includes(user.role)" class="col-12 align-middle mb-3">
            <label class="col-12" for="serviceAgreement">{{$t(userFields.insurance.serviceAgreement.label)}} *</label>
            <regular-input
              id="serviceAgreement"
              :value="user.insurance.serviceAgreement"
              @input="user.insurance.serviceAgreement = $event"
              type="number" :placeholder="$t(userFields.insurance.serviceAgreement.placeholder)" class="col-12 form-group"/>
          </div>
          
          <div class="col-12">
            <div v-if="user.insurance.isInsured">
              <label class="col-12" for="insuranceExpiration">{{$t(userFields.insurance.insuranceExpiration.label)}} *</label>
              <regular-input
                id="insuranceExpiration"
                :value="user.insurance.insuranceExpiration"
                @input="user.insurance.insuranceExpiration = $event"
                type="date" :placeholder="$t(userFields.insurance.insuranceExpiration.label)" class="col-12 form-group"/>
              
              <label class="col-12" for="insuranceDocuments">{{$t(userFields.insurance.insuranceDocuments.label)}}</label>
              <div class="col-12 mb-3">
                <table class="table" v-if="user.insuranceDocuments && user.insuranceDocuments.length>0">
                  <tbody>
                    <tr v-for="(insuranceDocument, index) in user.insuranceDocuments" :key="index">
                      <td class="col-3">
                        <regular-input
                          id="insuranceDocumentName"
                          :value="insuranceDocument.documentName"
                          @input="insuranceDocument.documentName = $event"
                          type="text" :placeholder="$t('Users.fields.common.otherDocumentsName')" class="col-12"/>
                      </td>
                      <td class="col-3">
                        <regular-input
                          id="insuranceDocumentExpiry"
                          :value="insuranceDocument.documentExpiry"
                          @input="insuranceDocument.documentExpiry = $event"
                          type="text" :placeholder="$t('Users.fields.common.documentExpiryPattern')" class="col-12"/>
                      </td>
                      <td class="col-5">
                        <custom-vue-dropzone
                          v-if = "!insuranceDocument.documentUrl"
                          :dropzoneMessage="$t(userFields.insurance.insuranceDocuments.dropzone)"
                          :maxFile="1"
                          :allowedFileTypes="['.pdf', '.jpeg', '.jpg', '.png']"
                          @dropzoneFile="uploadInsuranceDocument"
                        />
                        <p v-if="insuranceDocument.documentUrl">{{$t('Users.uploadedFiles')}}: <a :href="insuranceDocument.documentUrl" target="_blank">{{ insuranceDocument.documentUrl.split('_')[1] }}</a></p>
                      </td>
                      <td class="col-1"><button class="btn btn-light" @click="removeInsuranceDocument(index)"><strong>&times;</strong></button></td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-12 text-center">
                  <button class="btn btn-light" @click="addInsuranceDocument()">{{$t('Users.addDocument')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Fuel Cards Fields -->
        <div v-if="userFields.fuelCards.roles.includes(user.role)">
          <label class="col-12">{{$t(userFields.fuelCards.label)}}</label>
          <div class="col-12">
            <table class="table" v-if="user.fuelCards && user.fuelCards.length>0">
              <tbody>
                <tr v-for="fuelCard, index of user.fuelCards">
                  <td>
                    <regular-input
                      id="fuelCardName"
                      :value="fuelCard.fueldCardName"
                      @input="fuelCard.fueldCardName = $event"
                      type="text" :placeholder="$t(userFields.fuelCards.fueldCardName)" class="col-12"/>
                  </td>
                  <td>
                    <regular-input
                      id="fuelCardPIN"
                      :value="fuelCard.fueldCardPIN"
                      @input="fuelCard.fueldCardPIN = $event"
                      type="text" :placeholder="$t(userFields.fuelCards.fueldCardPIN)" class="col-12"/>
                  </td>
                  <td><button class="btn btn-light" @click="removeFuelCard(index)"><strong>&times;</strong></button></td>
                </tr>
              </tbody>
            </table>
            <div class="col-12 text-center">
              <button class="btn btn-light" @click="addFuelCard()">{{$t('Users.addFuelcard')}}</button>
            </div>
          </div>
        </div>

        <!-- Driver License Fields -->
        <div v-if="userFields.driverLicense.roles.includes(user.role)">
          <label class="col-12">{{$t(userFields.driverLicense.label)}} *</label>
          <div class="col-12">
            <table class="table">
              <tbody>
                <tr>
                  <td class="col-6">
                    <custom-vue-dropzone
                      :dropzoneMessage="$t(userFields.driverLicense.dropzone)"
                      :maxFile="2"
                      :allowedFileTypes="['.pdf', '.jpeg', '.jpg', '.png']"
                      @dropzoneFile="uploadDrivingLicense"
                    />
                  </td>
                  <td class="col-6">
                    <label class="col-12" for="licenseExpiration">{{$t(userFields.driverLicenseExpiration.label)}} *</label>
                    <regular-input
                      id="licenseExpiration"
                      :value="user.driverLicenseExpiration"
                      @input="user.driverLicenseExpiration = $event"
                      type="text" :placeholder="$t(userFields.driverLicenseExpiration.placeholder)" class="col-12 form-group"/>
                    
                    <label class="col-12" for="driverLicenseClass">{{$t(userFields.driverLicenseClass.label)}} *</label>
                    <regular-input
                      id="driverLicenseClass"
                      :value="user.driverLicenseClass"
                      @input="user.driverLicenseClass = $event"
                      type='text' :placeholder="$t(userFields.driverLicenseClass.placeholder)" class="col-12 form-group"/>
                  </td>
                </tr>
                <tr v-if="user.driverLicense">
                  <td><p class="col-12">{{$t('Users.uploadedFiles')}} : <span><a :href="user.driverLicense" target="_blank">{{ user.driverLicense.split('_')[1] }}</a></span></p></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Passport Fields -->
        <div v-if="userFields.passport.roles.includes(user.role)">
          <div class="col-12" v-if="user.driverCountry === 'US'">
            <label>{{$t(userFields.passport.label)}} *</label>
            <table class="table">
              <tbody>
                <tr>
                  <td class="col-6">
                    <custom-vue-dropzone
                      :dropzoneMessage="$t(userFields.passport.dropzone)"
                      :maxFile="1"
                      :allowedFileTypes="['.pdf', '.jpeg', '.jpg', '.png']"
                      @dropzoneFile="uploadPassport"
                    />
                  </td>
                  <td class="col-6">
                    <label class="col-12" for="licenseExpiration">{{$t(userFields.passportExpiration.label)}}*</label>
                    <regular-input
                      id="licenseExpiration"
                      :value="user.passportExpiration"
                      @input="user.passportExpiration = $event"
                      type="date" :placeholder="$t(userFields.passportExpiration.placeholder)" class="col-12 form-group"/>
                  </td>
                </tr>
                <tr v-if="user.passport">
                  <td><p class="col-12">{{$t('Users.uploadedFiles')}} : <span><a :href="user.passport" target="_blank">{{ user.passport.split('_')[1] }}</a></span></p></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="userFields.jockey.roles.includes(user.role)">
          <div class="row col-12 align-middle mb-3">
            <label class="col-3" for="jockeyCheckbox">{{$t(userFields.jockey.label)}}</label>
            <regular-checkbox
              :checked="user.jockey"
              @change="user.jockey = $event"
              class="p-0 col-3 hourlyCheckBox"/>
          </div>
        </div>

        <div v-if="userFields.rate.roles.includes(user.role)">
          <label class="col-12">{{$t(userFields.rate.label)}} *
            <hover-tool-tip
            :text="$t(userFields.rate.rate_description)"
            top
            right
            />
          </label> 
          <div class="col-12">
            <table class="table">
              <tbody>
                <tr>
                  <th class="align-middle" scope="row">{{ $t(userFields.rate.rateByCar.label) }}</th>
                  <td>
                    <regular-input
                      id="rate"
                      :value="user.rate.byCar"
                      @input="user.rate.byCar = $event"
                      type="number" :placeholder="$t(userFields.rate.rateByCar.placeholder)" class="col-12"/>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Other Documents Fields -->
        <div v-if="userFields.otherDocuments.roles.includes(user.role)">
          <label class="col-12">{{$t('Users.fields.common.otherDocuments')}}</label>
          <div class="col-12 mb-5">
            <table class="table" v-if="user.otherDocuments && user.otherDocuments.length>0">
              <tbody>
                <tr v-for="otherDocument, index of user.otherDocuments">
                  <td class="col-3">
                    <regular-input
                      id="otherDocumentName"
                      :value="otherDocument.documentName"
                      @input="otherDocument.documentName = $event"
                      type="text" :placeholder="$t(userFields.otherDocuments.otherDocumentName)" class="col-12"/>
                  </td>
                  <td class="col-3">
                    <regular-input
                      id="otherDocumentExpiry"
                      :value="otherDocument.documentExpiry"
                      @input="otherDocument.documentExpiry = $event"
                      type="text" :placeholder="$t(userFields.otherDocuments.documentExpiry)" class="col-12"/>
                  </td>
                  <td class="col-5">
                    <custom-vue-dropzone
                      v-if = "!otherDocument.documentUrl"
                      :dropzoneMessage="$t(userFields.otherDocuments.dropzone)"
                      :maxFile="1"
                      :allowedFileTypes="['.pdf', '.jpeg', '.jpg', '.png']"
                      @dropzoneFile="uploadOtherDocument"
                    />
                    <p v-if="otherDocument.documentUrl">{{$t('Users.uploadedFiles')}}: <a :href="otherDocument.documentUrl" target="_blank">{{ otherDocument.documentUrl.split('_')[1] }}</a></p>
                  </td>
                  <td class="col-1"><button class="btn btn-light" @click="removeOtherDocument(index)"><strong>&times;</strong></button></td>
                </tr>
              </tbody>
            </table>
            <div class="col-12 text-center">
              <button class="btn btn-light" @click="addOtherDocument()">{{$t('Users.addDocument')}}</button>
            </div>
          </div>
        </div>

        <div class="col-12">
          <p class="red-text">{{feedbackMessage}}</p>
          <button v-if="add" class="btn btn-kne-orange w-100" :disabled="!userFormCompleted" @click="addUser(user.email, user.password)">{{$t('Users.addUser')}}</button>
          <button v-else class="btn btn-kne-orange w-100" :disabled="!userFormCompleted || sisterCompaniesLoading" @click="modifyUser()">{{$t('Users.modifyUser')}}</button>
          <button v-if="modify && isAdmin && !isViewer" class="btn btn-secondary w-100 mt-2" @click="archiveUser()">{{$t('Users.archiveTitle')}}</button>
          <button v-if="modify && isAdmin && !isViewer" class="btn btn-danger w-100 mt-2" @click="deleteUser()">{{$t('Users.deleteTitle')}}</button>
        </div>
      </modal>
    </transition>

  </div>
</template>

<script>
import Modal from '../module/interface-components/Modal.vue'
import regularInput from '../module/basic-components/regularInput.vue'
import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import Search from '../module/special-components/Other-components/Search.vue'
import {db} from '../../firebase'
// import _ from 'lodash'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
import hoverToolTip from '../module/basic-components/hoverToolTip.vue'
import CustomVueDropzone from '../module/special-components/Custom-packages/Custom-VueDropzone.vue'
import userFields from '../../constants/userFieldMappings'
import enums from '../../constants/enums'
import isValidPhoneNumber from 'libphonenumber-js'
import moment from 'moment'
import { MultiSelect } from 'vue-search-select'
import { publishUserSyncRequest } from '../../odoo-sync-requests/user.js'
import { normalizeSisterCompanies } from '../../companyAccess'

export default {
  name: 'Users',

  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    Search,
    SidebarToggleButton,
    TableElement,
    LoadingRender,
    hoverToolTip,
    CustomVueDropzone,
    MultiSelect
  },

  props: {
    inactive: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      modalTitle: '',
      add: false,
      modify: false,
      modifyAuth: false,
      search: false,
      key: '',
      userFields,
      enums,
      user: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        role: '',
        email: '',
        password: '',
        companyName: '',
        tps: '',
        tvq: '',
        hiringDate: '',
        driverCountry: '',
        drivingRecord: '',
        agreedHourlyRate: {
          perHours: {
            on: 0,
            drive: 0
          },
          fixedHours: 0,
          perKM: 0,
          lastModificationDate: '',
          us: 0
        },
        insurance: {
          isInsured: true,
          insuranceAmount: 0,
          insuranceExpiration: '',
          serviceAgreement: 0
        },
        fuelCards: [],
        driverLicenseClass: '',
        driverLicense: '',
        driverLicenseExpiration: '',
        passport: '',
        passportExpiration: '',
        jockey: false,
        rate: {
          byCar: 0
        },
        otherDocuments: [],
        insuranceDocuments: [],
        distanceVariables: []
      },
      provinces: ['BC', 'ON', 'NL', 'NS', 'PE', 'NB', 'QC', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT'],
      fields: {
        firebase: '',
        lastName: '',
        phone: '',
        role: '',
        email: '',
        password: ''
      },
      filterResults: [],
      users: [],
      searchHistory: [],
      searchType: '',
      searchText: '',
      historyTypeTag: '',
      roles: {
        admin: {
          nameEN: 'Admin',
          nameFR: 'Administrateur',
          id: 1
        },
        dispatcher: {
          nameEN: 'Dispatcher',
          nameFR: 'Dispatch',
          id: 2
        },
        driver: {
          nameEN: 'Driver',
          nameFR: 'Chauffeur',
          id: 3
        },
        subcontractor: {
          nameEN: 'Subcontractor',
          nameFR: 'Sous-traitant',
          id: 4
        },
        boss: {
          nameEN: 'Boss',
          nameFR: 'Boss',
          id: 5
        },
        other: {
          nameEN: 'Other',
          nameFR: 'Autre',
          id: 6
        },
        exclusiveSubcontractor: {
          nameEN: 'Exclusive Subcontractor',
          nameFR: 'Sous-traitantExclusif',
          id: 7
        },
        viewer: {
          nameEN: 'Viewer',
          nameFR: 'Viewer',
          id: 8
        }
      },
      fieldsObj: [
        {
          text: this.$t('Users.firstName'),
          type: 'firstName',
          value: ''
        },
        {
          text: this.$t('Users.lastName'),
          type: 'lastName',
          value: ''
        },
        {
          text: this.$t('Users.email'),
          type: 'email',
          value: ''
        },
        {
          text: this.$t('Users.phone'),
          type: 'phoneNumber',
          value: ''
        },
        {
          text: this.$t('Users.role'),
          type: 'role',
          value: ''
        },
        {
          text: this.$t('Users.password'),
          type: 'password',
          value: ''
        },
        {
          text: 'Geotab',
          type: '',
          value: ''
        },
        {
          text: '',
          type: '',
          value: ''
        },
        {
          text: '',
          type: '',
          value: ''
        }
      ],
      feedbackMessage: '',
      drivers: [],
      selectedDrivers: [],
      selectedSisterCompanyUIDs: [],
      existingTargetSisterCompanies: {},
      sisterCompaniesLoading: false,
      sisterCompaniesLoaded: false
    }
  },

  created () {
    this.isLoading = true
    this.$store.state.isSidebarOpen = false
    this.isScreenSmall = window.innerWidth < 800
    this.getDrivers()
    this.$bindAsArray('users', db.ref('userInfos').child(this.companyUID), null, () => {
      this.isLoading = false
    })
  },

  watch: {
    'user.role': {
      handler (newValue, oldValue) {
        this.feedbackMessage = ''
      }
    }
  },

  methods: {
    toggleSisterCompany (companyUID, checked) {
      if (checked && !this.selectedSisterCompanyUIDs.includes(companyUID)) {
        this.selectedSisterCompanyUIDs.push(companyUID)
      } else if (!checked) {
        this.selectedSisterCompanyUIDs = this.selectedSisterCompanyUIDs.filter(uid => uid !== companyUID)
      }
    },

    authorizationRoleForUserRole (role) {
      if (role === this.enums.userRoles.admin) return 'Admin'
      if (role === this.enums.userRoles.dispatch) return 'Utilisateurs'
      if (role === this.enums.userRoles.viewer) return 'Viewer'
      return ''
    },

    normalizeSisterCompanyMap (sisterCompanies) {
      if (!sisterCompanies) return {}

      if (!Array.isArray(sisterCompanies) && typeof sisterCompanies === 'object') {
        return Object.keys(sisterCompanies).reduce((companies, uid) => {
          const company = sisterCompanies[uid]
          if (!company) return companies
          companies[uid] = typeof company === 'string'
            ? { companyName: company }
            : { ...company }
          return companies
        }, {})
      }

      return normalizeSisterCompanies(sisterCompanies).reduce((companies, company) => {
        companies[company.uid] = {
          companyName: company.companyName || company.uid,
          role: company.role,
          isUpdateSeen: company.isUpdateSeen
        }
        return companies
      }, {})
    },

    async loadTargetSisterCompanies (userUID) {
      this.selectedSisterCompanyUIDs = []
      this.existingTargetSisterCompanies = {}
      this.sisterCompaniesLoaded = false
      if (!this.canManageSisterCompanies) return

      this.sisterCompaniesLoading = true
      try {
        const snapshot = await db.ref('users/transportersman').child(userUID).child('sisterCompanies').once('value')
        if (!this.modify || this.key !== userUID) return

        this.existingTargetSisterCompanies = this.normalizeSisterCompanyMap(snapshot.val())
        this.selectedSisterCompanyUIDs = this.manageableSisterCompanies
          .filter(company => this.existingTargetSisterCompanies[company.uid])
          .map(company => company.uid)
        this.sisterCompaniesLoaded = true
      } catch (error) {
        if (this.modify && this.key === userUID) {
          this.feedbackMessage = this.$t('Users.sisterCompanyAccessLoadError')
        }
      } finally {
        if (this.key === userUID) this.sisterCompaniesLoading = false
      }
    },

    buildTargetSisterCompanies (authorizationRole) {
      const sisterCompanies = { ...this.existingTargetSisterCompanies }

      this.manageableSisterCompanies.forEach(company => {
        if (!this.selectedSisterCompanyUIDs.includes(company.uid)) {
          delete sisterCompanies[company.uid]
          return
        }

        const existingCompany = sisterCompanies[company.uid] || {}
        sisterCompanies[company.uid] = {
          ...existingCompany,
          companyName: company.companyName || existingCompany.companyName || company.uid,
          role: authorizationRole
        }
        if (typeof existingCompany.isUpdateSeen !== 'boolean') {
          sisterCompanies[company.uid].isUpdateSeen = false
        }
      })

      return Object.keys(sisterCompanies).length ? sisterCompanies : null
    },

    getDrivers () {
      db.ref('database/transporter').child(this.companyUID).child('geotab/drivers').once('value', (snapshot) => {
        if (!snapshot.exists()) return
        Object.entries(snapshot.val()).forEach(([id, user]) => {
            this.drivers.push({
              value: id,
              text: user.firstName + ' ' + user.lastName
            })
        })
      })
    },

    isGeotabDriverMapped (id) {
      return this.drivers.filter(driver => driver.value === id).length
    },

    handleDriversSelect: function (list) {
      if (!list.length) {
        this.selectedDrivers = []
        return
      }
      if (list.length === 1) {
        this.user.geotabId = list[0].value
        this.selectedDrivers = list
        return
      }
      this.user.geotabId = list[1].value
      this.selectedDrivers = [list[1]]
    },

    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    getRole (receivedRole) {
      const role = this.capitalizeFirstLetter(receivedRole)

      switch (role) {
        case (this.roles.admin.nameFR):
          return this.$t('Users.admin')

        case (this.roles.dispatcher.nameFR):
          return this.$t('Users.dispatch')

        case (this.roles.driver.nameFR):
          return this.$t('Users.driver')

        case (this.roles.subcontractor.nameFR):
          return this.$t('Users.subcontractor')

        case (this.roles.exclusiveSubcontractor.nameFR):
          return this.$t('Users.exclusiveSubcontractor')

        case (this.roles.boss.nameFR):
          return this.$t('Users.boss')

        case (this.roles.other.nameFR):
          return this.$t('Users.other')

        case (this.roles.viewer.nameFR):
          return this.$t('Users.viewer')

        default:
          console.log('Got role error. D:')
          break
      }
    },

    capitalizeFirstLetter (message) {
      message = message ? message.charAt(0).toUpperCase() + message.slice(1) : ''
      return message
    },

    setModalTitle (title) {
      this.modalTitle = title
    },

    openModalAddUser () {
      // Method to open the modal
      this.selectedDrivers = []
      this.add = true
      this.modalTitle = this.$t('Users.addUserTitle')
    },

    addUser (email, password) {
      if (!this.checkUserInfo(this.user)) return
      this.validateDistanceVariables()
      window.axios.get(`${process.env.API_ENDPOINT}/decode/auth/` + this.user.email + '/' + this.user.password).then((response) => {
        this.user.lastModificationDate = moment().toISOString()
        // Password > 6
        if (response.data.error) {
          throw new Error(response.data.error)
        }
        db.ref('database/transporter/' + this.companyUID + '/user/employees').child(response.data.uid).child('infos').set(this.user).then(() => {
          publishUserSyncRequest(this.companyUID, response.data.uid)
        })
        db.ref('users/deliverman').child(response.data.uid).set(this.companyUID).catch((error) => console.log('Set deliverman error:', error))
        db.ref('database/transporter/' + this.companyUID + '/liste').child(response.data.uid).set(this.user.firstName + ' ' + this.user.lastName)
        if (this.user.role === this.enums.userRoles.dispatch) {
          db.ref('users/transportersman').child(response.data.uid).set({'company': this.companyUID, 'role': 'Utilisateurs'})
        } else if (this.user.role === this.enums.userRoles.admin) {
          db.ref('users/transportersman').child(response.data.uid).set({'company': this.companyUID, 'role': 'Admin'})
        } else if (this.user.role === this.enums.userRoles.viewer) {
          db.ref('users/transportersman').child(response.data.uid).set({'company': this.companyUID, 'role': 'Viewer'})
        }
        // ======================== ADD CREATED USER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_USER', 'createdUserUID': response.data.uid, 'date': Date.now(), 'createdUserName': this.user.firstName + ' ' + this.user.lastName})
        // ======================== ADD CREATED USER LOG =======================

        this.clear()
        this.add = !this.add
      }).catch(error => {
        const errorMessage = error.toString().replace('Error: ', '')
        this.processError(errorMessage)
      })
    },

    processError (errorCode) {
      if (errorCode === 'USER_CREATE_ERROR') this.feedbackMessage = this.$t('Users.modal.error.email_unavailable')
    },

    checkUserInfo (user) {
      // Common Required Fields
      if (!this.validateRequiredField(this.userFields.role.label, user.role)) return
      if (!this.validateRequiredField(this.userFields.firstName.label(user.role), user.firstName)) return
      if (!this.validateRequiredField(this.userFields.lastName.label(user.role), user.lastName)) return
      if (!this.validateRequiredField(this.userFields.phoneNumber.label, user.phoneNumber)) return
      // if (!this.validatePhone(user.phoneNumber)) return
      if (!this.validateRequiredField(this.userFields.password.label, user.password)) return
      if (!this.checkEmail(user.email)) return
      if (!this.checkPassword(user.password)) return

      // Required Fields for Driver
      if (this.add && user.role === this.enums.userRoles.driver) {
        if (!this.validateRequiredField(this.userFields.hiringDate.label, user.hiringDate) ||
            !this.validateRequiredField(this.userFields.driverCountry.label, user.driverCountry) ||
            !this.validateRequiredField(this.userFields.drivingRecord.label, user.drivingRecord) ||
            !this.validateAgreedHourlyRate(user.agreedHourlyRate) ||
            !this.validateRequiredField(this.userFields.driverLicenseClass.label, user.driverLicenseClass) ||
            !this.validateRequiredField(this.userFields.driverLicense.label, user.driverLicense) ||
            !this.validateRequiredField(this.userFields.driverLicenseExpiration.label, user.driverLicenseExpiration) ||
            !this.validateExpiry(this.userFields.driverLicenseExpiration.label, user.driverLicenseExpiration) ||
            (user.driverCountry === 'US' &&
                (!this.validateRequiredField(this.userFields.passport.label, user.passport) ||
                !this.validateRequiredField(this.userFields.passportExpiration.label, user.passportExpiration))) ||
            !this.validateDocuments(this.userFields.otherDocuments.otherDocuments, user.otherDocuments)) {
            return
        }
      }

      // Required Fields for Exclusive Subcontractor
      if (this.add && user.role === enums.userRoles.exclusiveSubcontractor) {
        if (!this.validateRequiredField(this.userFields.companyName.label, user.companyName) ||
            !this.validateRequiredField(this.userFields.tps.label, user.tps) ||
            !this.validateRequiredField(this.userFields.tvq.label, user.tvq) ||
            !this.validateRequiredField(this.userFields.hiringDate.label, user.hiringDate) ||
            !this.validateRequiredField(this.userFields.driverCountry.label, user.driverCountry) ||
            !this.validateRequiredField(this.userFields.drivingRecord.label, user.drivingRecord) ||
            (user.insurance.isInsured &&
                (!this.validateRequiredField(this.userFields.insurance.insuranceAmount.label, user.insurance.insuranceAmount) ||
                !this.validateRequiredField(this.userFields.insurance.insuranceExpiration.label, user.insurance.insuranceExpiration))) ||
            !this.validateRequiredField(this.userFields.rate.rateByCar.label, user.rate.byCar) ||
            !this.validateRequiredField(this.userFields.driverLicenseClass.label, user.driverLicenseClass) ||
            !this.validateRequiredField(this.userFields.driverLicense.label, user.driverLicense) ||
            !this.validateRequiredField(this.userFields.driverLicenseExpiration.label, user.driverLicenseExpiration) ||
            !this.validateExpiry(this.userFields.driverLicenseExpiration.label, user.driverLicenseExpiration) ||
            (user.driverCountry === 'US' &&
                (!this.validateRequiredField(this.userFields.passport.label, user.passport) ||
                !this.validateRequiredField(this.userFields.passportExpiration.label, user.passportExpiration))) ||
                !this.validateDocuments(this.userFields.otherDocuments.otherDocuments, user.otherDocuments)) {
            return
        }
      }

      // Required Fields for Subcontractor
      if (this.add && user.role === this.enums.userRoles.subcontractor) {
        if (!this.validateRequiredField(this.userFields.companyName.label, user.companyName) ||
            !this.validateRequiredField(this.userFields.tps.label, user.tps) ||
            !this.validateRequiredField(this.userFields.tvq.label, user.tvq) ||
            !this.validateRequiredField(this.userFields.hiringDate.label, user.hiringDate) ||
            !this.validateRequiredField(this.userFields.driverCountry.label, user.driverCountry) ||
            !this.validateRequiredField(this.userFields.insurance.serviceAgreement.label, user.insurance.serviceAgreement) ||
            !this.validateRequiredField(this.userFields.insurance.insuranceExpiration.label, user.insurance.insuranceExpiration) ||
            !this.validateDocuments(this.userFields.otherDocuments.otherDocuments, user.otherDocuments)) {
            return
        }
      }

      return true
    },

    checkEmail (email) {
      if (!this.validateEmail(email)) {
        this.feedbackMessage = this.$t('Users.modal.email_invalid_format')
        return false
      } else {
        this.feedbackMessage = ''
        return true
      }
    },

    /** Regex of javascript email
     * @link https://www.emailregex.com/ */
    validateEmail (email) {
      if (email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) return true
      else return false
    },

    validatePhone (phone) {
      if (!isValidPhoneNumber(phone)) {
        this.feedbackMessage = 'Phone number not valid'
        return false
      } else {
        this.feedbackMessage = ''
        return true
      }
    },

    checkPassword (password) {
      if (password.length < 6) {
        this.feedbackMessage = `${this.$t('Users.modal.password_feedback')} '${password.length}' ${this.$t('Users.modal.characters')}`
        return false
      } else {
        this.feedbackMessage = ''
        return true
      }
    },

    validateExpiry (field, value, required = true) {
      if (!required && !value) {
        this.feedbackMessage = ''
        return true
      }
      // Regular expression for mm/yyyy format
      const regex = /^(0[1-9]|1[0-2])\/\d{4}$/
      if (regex.test(value)) {
        this.feedbackMessage = ''
        return true
      } else {
        this.feedbackMessage = this.$t('Users.modal.invalidExpiryFormat') + this.$t(field)
        return false
      }
    },

    validateRequiredField (field, value) {
      if (!value) {
        this.feedbackMessage = this.$t('Users.modal.requiredField') + this.$t(field)
        return false
      } else {
        this.feedbackMessage = ''
        return true
      }
    },

    validateDocuments (field, documents) {
      let validFlag = true
      documents.forEach((document) => {
        if (!this.validateExpiry(field, document.documentExpiry)) {
          this.feedbackMessage = this.$t('Vehicles.errors.invalidExpiryFormat') + this.$t(field)
          validFlag = false
        } else if (!document.documentName || !document.documentUrl) {
          this.feedbackMessage = this.$t('Vehicles.errors.nonEmptyField') + this.$t(field)
          validFlag = false
        }
      })
      return validFlag
    },

    validateAgreedHourlyRate (agreedHourlyRate) {
      if (!agreedHourlyRate.perHours.on ||
          !agreedHourlyRate.perHours.drive ||
          !agreedHourlyRate.us
        ) {
        this.feedbackMessage = this.$t('Users.modal.requiredField') + this.$t('Users.fields.driver.agreedHourlyRate')
        return false
      }
      this.feedbackMessage = ''
      return true
    },

    uploadDrivingRecord (file) {
      this.user.drivingRecord = file
    },

    uploadDrivingLicense (file) {
      this.user.driverLicense = file
    },

    uploadPassport (file) {
      this.user.passport = file
    },

    uploadOtherDocument (file) {
      if (file) {
        this.user.otherDocuments[this.user.otherDocuments.length - 1].documentUrl = file
      }
    },

    uploadInsuranceDocument (file) {
      if (file) {
        this.user.insuranceDocuments[this.user.insuranceDocuments.length - 1].documentUrl = file
      }
    },

    addFuelCard () {
      const fuelCardsData = this.user.fuelCards
      if ((fuelCardsData.length > 0 && fuelCardsData[fuelCardsData.length - 1].fueldCardName && fuelCardsData[fuelCardsData.length - 1].fueldCardPIN) || fuelCardsData.length === 0) {
        this.user.fuelCards.push(
          {
            fueldCardName: '',
            fueldCardPIN: ''
          }
        )
      }
    },

    removeFuelCard (id) {
      this.user.fuelCards.splice(id, 1)
    },

    addOtherDocument () {
      const documentData = this.user.otherDocuments

      if ((documentData.length > 0 &&
      documentData[documentData.length - 1].documentName &&
      documentData[documentData.length - 1].documentExpiry &&
      documentData[documentData.length - 1].documentUrl) ||
      documentData.length === 0) {
        this.user.otherDocuments.push(
          {
            documentName: '',
            documentExpiry: '',
            documentUrl: ''
          }
        )
      }
    },

    removeOtherDocument (id) {
      this.user.otherDocuments.splice(id, 1)
    },

    addInsuranceDocument () {
      const documentData = this.user.insuranceDocuments
      if ((documentData.length > 0 &&
      documentData[documentData.length - 1].documentName &&
      documentData[documentData.length - 1].documentExpiry &&
      documentData[documentData.length - 1].documentUrl) ||
      documentData.length === 0) {
        this.user.insuranceDocuments.push(
          {
            documentName: '',
            documentExpiry: '',
            documentUrl: ''
          }
        )
      }
    },

    removeInsuranceDocument (id) {
      this.user.insuranceDocuments.splice(id, 1)
    },

    validateDistanceVariables () {
      for (let i in this.user.distanceVariables) {
        if (i === '0') {
          this.user.distanceVariables[i].lower = 0
          if (!this.user.distanceVariables[i].upper) {
            this.user.distanceVariables[i].upper = 500
          }
        }
        if (i > 0) {
          this.user.distanceVariables[i].lower = parseInt(this.user.distanceVariables[i - 1].upper) + 1
          if (!this.user.distanceVariables[i].upper || this.user.distanceVariables[i].upper < this.user.distanceVariables[i].lower) {
            this.user.distanceVariables[i].upper = parseInt(this.user.distanceVariables[i].lower) + 99
          }
        }
      }
    },

    addDistanceVariables () {
      const distanceVariablesData = this.user.distanceVariables
      const dsObject = { lower: null, upper: 0, value: 0 }
      if (distanceVariablesData.length === 0) {
        dsObject.lower = 0
        this.user.distanceVariables.push(dsObject)
      } else if (distanceVariablesData.length === 1) {
        this.user.distanceVariables[0].upper = 500
        dsObject.lower = 501
        this.user.distanceVariables.push(dsObject)
      } else {
        this.user.distanceVariables[distanceVariablesData.length - 1].upper = parseInt(distanceVariablesData[distanceVariablesData.length - 1].lower) + 99
        dsObject.lower = parseInt(this.user.distanceVariables[distanceVariablesData.length - 1].upper) + 1
        this.user.distanceVariables.push(dsObject)
      }
    },

    removeDistanceVariables (id) {
      this.user.distanceVariables.splice(id, 1)
      this.validateDistanceVariables()
    },

    modifyUser: function () {
      if (this.sisterCompaniesLoading) return
      if (!this.checkUserInfo(this.user)) return
      this.validateDistanceVariables()
      this.user.geotabId = this.selectedDrivers && this.selectedDrivers.length ? this.selectedDrivers[0].value : ''
      db.ref('database/transporter/' + this.companyUID + '/user/employees/' + this.key + '/infos').update(this.user).then(() => {
        publishUserSyncRequest(this.companyUID, this.key)
      })
      db.ref('database/transporter/' + this.companyUID + '/liste/' + this.key).set(this.user.firstName + ' ' + this.user.lastName)
      const authorizationRole = this.authorizationRoleForUserRole(this.user.role)
      if (authorizationRole) {
        const authorizationUpdate = {'company': this.companyUID, 'role': authorizationRole}
        if (this.canManageSisterCompanies && this.sisterCompaniesLoaded) {
          authorizationUpdate.sisterCompanies = this.buildTargetSisterCompanies(authorizationRole)
        }
        db.ref('users/transportersman').child(this.key).update(authorizationUpdate)
      } else {
        db.ref('users/transportersman').child(this.key).remove()
      }
      // ======================== ADD MODIFY USER LOG =======================
      this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'MODIFY_USER', 'modifiedUserUID': this.key, 'date': Date.now(), 'modifiedUserName': this.user.firstName + ' ' + this.user.lastName})
      // ======================== ADD MODIFY USER LOG =======================
      this.modify = !this.modify
      this.clear()
    },

    deleteUser: function () {
      db.ref('database/transporter/' + this.companyUID + '/user/employees/' + this.key).remove()
      db.ref('database/transporter/' + this.companyUID + '/liste/' + this.key).remove()
      db.ref('users/deliverman').child(this.key).remove()
      db.ref('users/transportersman').child(this.key).remove()
      // ======================== ADD DELETED USER LOG =======================
      this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'DELETE_USER', 'deletedUserUID': this.key, 'date': Date.now(), 'deletedUserName': this.user.firstName + ' ' + this.user.lastName})
      // ======================== ADD DELETED USER LOG =======================
      this.modify = !this.modify
      this.clear()
    },

    archiveUser: function () {
      if (!confirm(this.$t('Users.archiveConfirm'))) return
      const uid = this.key
      const userName = this.user.firstName + ' ' + this.user.lastName
      db.ref().update({
        [`database/transporter/${this.companyUID}/user/employees/${uid}/infos/isInactive`]: true,
        [`userInfos/${this.companyUID}/${uid}/isInactive`]: true,
        [`database/transporter/${this.companyUID}/liste/${uid}`]: null,
        [`users/deliverman/${uid}`]: null,
        [`users/transportersman/${uid}`]: null
      }).then(() => {
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ARCHIVE_USER', 'archivedUserUID': uid, 'date': Date.now(), 'archivedUserName': userName})
        this.modify = false
        this.clear()
      }).catch((error) => {
        console.error('Archive user error:', error)
        this.feedbackMessage = this.$t('Users.archiveError')
      })
    },

    reactivateUser: function (user) {
      const uid = user['.key']
      const userName = user.firstName + ' ' + user.lastName
      const updates = {
        [`database/transporter/${this.companyUID}/user/employees/${uid}/infos/isInactive`]: false,
        [`userInfos/${this.companyUID}/${uid}/isInactive`]: false,
        [`database/transporter/${this.companyUID}/liste/${uid}`]: userName,
        [`users/deliverman/${uid}`]: this.companyUID
      }
      const authorizationRole = this.authorizationRoleForUserRole(user.role)
      if (authorizationRole) {
        updates[`users/transportersman/${uid}`] = {'company': this.companyUID, 'role': authorizationRole}
      }
      db.ref().update(updates).then(() => {
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'REACTIVATE_USER', 'reactivatedUserUID': uid, 'date': Date.now(), 'reactivatedUserName': userName})
      }).catch((error) => {
        console.error('Reactivate user error:', error)
        alert(this.$t('Users.reactivateError'))
      })
    },

    modifying: async function (user) {
      this.modify = true
      this.key = user['.key']
      this.selectedDrivers = []
      this.drivers.forEach(driver => {
        if (driver.value === user.geotabId) {
          this.selectedDrivers = [driver]
        }
      })
      for (var attr in this.user) {
        if (!(user[attr] === undefined || user[attr] === null || typeof user[attr] !== typeof this.user[attr])) {
          this.user[attr] = user[attr]
        }
      }
      if (user.role === this.enums.userRoles.driver) {
        if (!this.user.agreedHourlyRate.selectedField) this.user.agreedHourlyRate.selectedField = 'perHours'
        if (!this.user.agreedHourlyRate.perHours.on) this.user.agreedHourlyRate.perHours.on = 0
        if (!this.user.agreedHourlyRate.perHours.drive) this.user.agreedHourlyRate.perHours.drive = 0
        if (!this.user.agreedHourlyRate.fixedHours) this.user.agreedHourlyRate.fixedHours = 0
        if (!this.user.agreedHourlyRate.perKM) this.user.agreedHourlyRate.perKM = 0
        if (!this.user.agreedHourlyRate.us) this.user.agreedHourlyRate.us = 0
      }
      if (user.role === this.enums.userRoles.exclusiveSubcontractor) {
        if (!this.user.insurance.insuranceAmount) this.user.insurance.insuranceAmount = 0
        if (!this.user.insuranceDocuments) this.user.insuranceDocuments = []
      }
      if (user.role === this.enums.userRoles.subcontractor) {
        if (!this.user.insurance.serviceAgreement) this.user.insurance.serviceAgreement = 0
        if (!this.user.insuranceDocuments) this.user.insuranceDocuments = []
      }
      await this.loadTargetSisterCompanies(this.key)
    },

    modifyingAuth: function (user) {
      this.modifyAuth = true
      this.user = user
    },

    async updateUserCredentials () {
      const payload = {
        uid: this.user['.key'],
        email: this.user.email || null,
        password: this.user.password || null
      }

      if (!payload.email && !payload.password) {
        alert(this.$t('Users.modal.nothing_to_update'))
        return
      }

      try {
        const response = await fetch(`${process.env.BACKEND_API_URL}/update-user-auth`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })

        if (response.ok) {
          alert('User credentials updated successfully.')
        } else {
          const errorText = await response.text()
          alert('Update failed: ' + errorText)
        }
      } catch (err) {
        console.error('Fetch error:', err)
        alert('An error occurred.')
      }
    },

    clear: function () {
      for (var attr in this.user) {
        if (typeof this.user[attr] === 'string') {
          this.user[attr] = ''
        } else if (Array.isArray(this.user[attr])) {
          this.user[attr] = []
        } else if (attr === 'agreedHourlyRate') {
          this.user[attr] = {
            perHours: {
              on: 0,
              drive: 0
            },
            fixedHours: 0,
            perKM: 0,
            lastModificationDate: '',
            selectedField: 'perHours',
            us: 0
          }
        } else if (attr === 'insurance') {
          this.user[attr] = {
            isInsured: true,
            insuranceAmount: null,
            insuranceDocuments: [],
            insuranceExpiration: '',
            serviceAgreement: null
          }
        }
      }
      this.feedbackMessage = ''
      this.selectedSisterCompanyUIDs = []
      this.existingTargetSisterCompanies = {}
      this.sisterCompaniesLoading = false
      this.sisterCompaniesLoaded = false
      this.isLoading = true
      this.$bindAsArray('users', db.ref('userInfos').child(this.companyUID), null, () => {
        this.isLoading = false
      })
    },

    onResize: window._.debounce(function () {
      this.isScreenSmall = window.innerWidth < 800
    }, 50)
  },

  computed: {
    displayedUsers () {
      return this.users.filter(user => Boolean(user.isInactive) === this.inactive)
    },
    userFormCompleted: function () {
      if (
        this.user.firstName !== '' &&
        this.user.lastName !== '' &&
        this.user.phoneNumber !== '' &&
        this.user.role !== '' &&
        this.user.email !== '' &&
        this.user.password !== '') return true
      else return false
    },
    uid () {
      return this.$store.state.user.uid
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    },
    isViewer () {
      return this.$store.state.authorization.role === 'Viewer'
    },
    manageableSisterCompanies () {
      const primaryAuthorization = this.$store.state.primaryAuthorization || {}
      const availableCompanies = this.$store.state.availableCompanies || []

      return normalizeSisterCompanies(primaryAuthorization.sisterCompanies)
        .filter(company => company.uid !== this.companyUID)
        .map(company => {
          const loadedCompany = availableCompanies.find(available => available.uid === company.uid)
          return loadedCompany || company
        })
    },
    canManageSisterCompanies () {
      return this.modify && this.isAdmin && this.manageableSisterCompanies.length > 0
    },
    showSisterCompanyAccess () {
      return this.canManageSisterCompanies && Boolean(this.authorizationRoleForUserRole(this.user.role))
    }
  },

  mounted () {
    this.onResize()
    this.$parent.$on('open-add-user-modal', this.openModalAddUser)
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy () {
    this.$parent.$off('open-add-user-modal', this.openModalAddUser)
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
.hourlyCheckBox {
  display: flex;
  align-items: center;
}
label {
  font-weight: 600;
}
.sister-company-access {
  padding: 12px 15px 4px;
  border: 1px solid #eceeef;
  border-radius: 4px;
}
.sister-company-access__help {
  margin-bottom: 8px;
  color: #6c757d;
}
</style>
